export function convertiTimestamp({ _seconds, _nanoseconds }) {
    return new Date (_seconds * 1000 + _nanoseconds / 1000000);
}